/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M.8768 10.7499 7.75.0507l6.8733 10.6992h-4.1232v10.6884c0 .9665-.7835 1.75-1.75 1.75h-2c-.9665 0-1.75-.7835-1.75-1.75V10.7499H.8767Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m18.1627 23.9493-6.8733-10.6992h4.1233V2.5617c0-.9665.7835-1.75 1.75-1.75h2c.9665 0 1.75.7835 1.75 1.75v10.6884h4.1232l-6.8732 10.6992Zm-1.25-9.9492a.75.75 0 0 1-.75.75h-2.1268l4.1268 6.424 4.1267-6.424h-2.1267a.7502.7502 0 0 1-.75-.75V2.5617a.25.25 0 0 0-.25-.25h-2a.25.25 0 0 0-.25.25v11.4384Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuUsageInsightsFilled'
);
